<template>
  <div class="avatar-container">
    <div class="avatar-name">
      <span>欢迎您，{{ userInfo.name }}</span>
      <span
        class="avatar-name-icon"
        @click.stop="toggleUserMenus"
      >
        <img src="@/assets/images/layout/icon_xiala@2x.png" />
        <div
          class="UserMenus"
          v-if="userMenusVisble"
        >
          <div
            class="UserMenus-Link"
            @click="showUserinfoDialog"
          >
            <span class="UserMenus-Link-icon">
              <img src="@/assets/images/layout/icon_ziliao.png" />
            </span>
            修改资料
          </div>
          <div
            class="UserMenus-Link"
            @click="cellphoneDialogVisible = true"
          >
            <span class="UserMenus-Link-icon">
              <img src="@/assets/images/layout/icon_xiugai.png" />
            </span>
            修改手机号
          </div>
          <div
            class="UserMenus-Link"
            @click="logout"
          >
            <span class="UserMenus-Link-icon">
              <img src="@/assets/images/layout/icon_tuichu.png" />
            </span>
            退出登录
          </div>
        </div>
      </span>
    </div>
    <TimeBox />

    <normal-dialog
      title="修改密码"
      :visible="dialogVisible"
      width="50%"
      :before-close="cancelPwdUpdate"
      :close-on-click-modal="!showSetPassword"
      :show-close="!showSetPassword"
    >
      <el-form
        :model="pwd"
        :rules="rules"
        ref="pwdForm"
      >
        <el-form-item
          label="原密码"
          prop="oldPwd"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            v-model="pwd.oldPwd"
            placeholder="请输入原密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="新密码"
          prop="newPwd"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            v-model="pwd.newPwd"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="重复新密码"
          prop="rePwd"
          :label-width="formLabelWidth"
        >
          <el-input
            type="password"
            v-model="pwd.rePwd"
            placeholder="请再输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <p
            class="setpwd-info"
            v-if="showSetPassword"
          >
            原始密码登陆请务必修改密码
          </p>
        </el-form-item>
      </el-form>
      <span
        v-if="showSetPassword"
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="checkPwdForm"
        >确 定</el-button>
      </span>
      <span
        v-else
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="resetPwdForm">取 消</el-button>
        <el-button
          type="primary"
          @click="checkPwdForm"
        >确 定</el-button>
      </span>
    </normal-dialog>

    <normal-dialog
      title="修改资料"
      :visible="userInfoDialogVisible"
      width="500px"
      :before-close="cancelUserinfoUpdate"
      class="userForm"
    >
      <el-form label-width="120px">
        <el-form-item label="登录账户">{{userInfo.loginAccount}}</el-form-item>
        <el-form-item label="姓名">
          <!-- <el-input
            v-model="userForm.name"
            maxlength="20"
            placeholder="请输入姓名"
          ></el-input> -->
          {{userInfo.name}}
        </el-form-item>
        <el-form-item label="运营商">{{userInfo.operateName}}</el-form-item>
        <el-form-item label="手机号">{{userInfo.cellphone}}</el-form-item>
        <el-form-item label="当前登录密码">
          <el-input
            v-model="userForm.pwd"
            :type="showPwd?'text':'password'"
            maxlength="20"
            placeholder="请输入当前登录密码"
          ></el-input>
          <div
            class="showPassword"
            @click="showPwd = !showPwd"
          >
            <img
              v-if="showPwd"
              src="@/assets/images/layout/icon_sel@2x.png"
            />
            <img
              v-else
              src="@/assets/images/layout/icon_nor@2x.png"
            >
          </div>
        </el-form-item>
        <el-form-item label="设置新密码">
          <el-input
            v-model="userForm.newPwd"
            :type="showNewPwd?'text':'password'"
            maxlength="20"
            placeholder="请输入新密码"
          ></el-input>
          <div
            class="showPassword"
            @click="showNewPwd = !showNewPwd"
          >
            <img
              v-if="showNewPwd"
              src="@/assets/images/layout/icon_sel@2x.png"
            />
            <img
              v-else
              src="@/assets/images/layout/icon_nor@2x.png"
            >
          </div>
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input
            v-model="userForm.checkPwd"
            :type="showCheckPwd?'text':'password'"
            maxlength="20"
            placeholder="请再次输入新密码"
          ></el-input>
          <div
            class="showPassword"
            @click="showCheckPwd = !showCheckPwd"
          >
            <img
              v-if="showCheckPwd"
              src="@/assets/images/layout/icon_sel@2x.png"
            />
            <img
              v-else
              src="@/assets/images/layout/icon_nor@2x.png"
            >
          </div>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button
          type="primary"
          @click="updateUserinfoHandle"
          :disabled="loading"
        >确定</el-button>
        <el-button @click="cancelUserinfoUpdate">取消</el-button>
      </div>
    </normal-dialog>

    <normal-dialog
      title="修改手机号"
      :visible="cellphoneDialogVisible"
      width="500px"
      :before-close="cancelCellphoneUpdate"
      class="cellphoneForm"
    >
      <el-form
        label-width="120px"
        v-loading="loading"
      >
        <el-form-item label="登录账户">{{userInfo.loginAccount}}</el-form-item>
        <el-form-item label="姓名">{{userInfo.name}}</el-form-item>
        <el-form-item label="运营商">{{userInfo.operateName}}</el-form-item>
        <el-form-item label="手机号">{{userInfo.cellphone}}</el-form-item>
        <el-form-item label="更换手机账户">
          <el-input
            v-model="cellphoneForm.cellphone"
            maxlength="11"
            placeholder="请输入更换手机账户"
          ></el-input>
        </el-form-item>
        <el-form-item label="输入验证码">
          <div class="vcode-wrap">
            <el-input
              v-model="cellphoneForm.vcode"
              maxlength="6"
              placeholder="验证码"
            ></el-input>
            <Vcode
              class="vcode-box"
              :cellphone="cellphoneForm.cellphone"
            />
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          @click="updateCellphone"
          :disabled="loading"
        >确定</el-button>
        <el-button @click="cancelCellphoneUpdate">取消</el-button>
      </div>
      <!-- <normal-dialog
        title="输入图形验证码"
        :visible="vcodeVisible"
        width="330px"
        top="20vh"
        :before-close="cancelVcode"
        append-to-body
        class="cellphoneForm"
      >
        <div class="img-code-box">
          <div>
            <el-input v-model="cellphoneForm.imgCode" />
          </div>
          <div class="code-img">
            <CodeView :value="cellphoneForm.svcode" />
          </div>
        </div>
      </normal-dialog> -->
    </normal-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TimeBox from './TimeBox';
// import CodeView from '../../login/components/CodeView';
import Vcode from './Vcode';

export default {
  components: {
    TimeBox,
    Vcode,
    // CodeView,
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.pwd.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      userMenusVisble: false,
      userInfoDialogVisible: false,
      cellphoneDialogVisible: false,
      dialogVisible: false,
      vcodeVisible: false,
      formLabelWidth: '200px',
      pwd: {
        oldPwd: '',
        newPwd: '',
        rePwd: '',
      },
      rules: {
        oldPwd: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPwd: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        rePwd: [
          { required: true, message: '请再输入新密码', trigger: 'blur' },
          { validator: validatePass },
        ],
      },
      userForm: {
        name: '',
        pwd: '',
        newPwd: '',
        checkPwd: '',
      },
      showPwd: false,
      showNewPwd: false,
      showCheckPwd: false,
      cellphoneForm: {
        cellphone: '',
        vcode: '',
        imgCode: '',
        svcode: '',
      },
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'loading']),
    showSetPassword() {
      return this.userInfo && this.userInfo.isSetPassword === 0;
    },
  },
  mounted() {
    this.dialogVisible = this.showSetPassword;
  },
  watch: {
    userInfo(nVal) {
      if (nVal && nVal.isSetPassword === 0) {
        this.dialogVisible = true;
      }
    },
  },
  methods: {
    ...mapActions(['updatePassword', 'updateUserinfo', 'updateUserCellphone']),
    toggleUserMenus() {
      this.userMenusVisble = !this.userMenusVisble;
      setTimeout(() => {
        if (this.userMenusVisble) {
          document.addEventListener('click', this.toggleUserMenus);
        } else {
          document.removeEventListener('click', this.toggleUserMenus);
        }
      }, 400);
    },
    cancelPwdUpdate(done) {
      this.resetPwdForm();
      done();
    },
    resetPwdForm() {
      this.$refs.pwdForm.resetFields();
      this.dialogVisible = false;
    },
    checkPwdForm() {
      this.$refs.pwdForm.validate(valid => {
        if (valid) {
          this.updatePassword(this.pwd)
            .then(() => {
              this.$message.success('修改密码成功!');
              this.resetPwdForm();
            })
            .catch(err => {
              console.error(err);
              // this.$message.error('修改密码失败!');
            });
        }
      });
    },
    logout() {
      this.$store.dispatch('FedLogOut').then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    showUserinfoDialog() {
      this.userForm = {
        name: this.userInfo.name,
        pwd: '',
        newPwd: '',
        checkPwd: '',
      };
      this.userInfoDialogVisible = true;
    },
    cancelUserinfoUpdate(done) {
      this.resetUserForm();
      typeof done === 'function' && done();
    },
    resetUserForm() {
      this.userForm = {
        name: '',
        pwd: '',
        newPwd: '',
        checkPwd: '',
      };
      this.userInfoDialogVisible = false;
    },
    validateUserForm() {
      if (!this.userForm.name) {
        this.$message.error('请输入姓名');
        return;
      }
      if (this.userForm.newPwd) {
        if (!this.userForm.pwd) {
          this.$message.error('请输入密码');
          return;
        }
        if (!this.userForm.checkPwd) {
          this.$message.error('请再次输入新密码');
          return;
        }
        if (this.userForm.newPwd !== this.userForm.checkPwd) {
          this.$message.error('两次输入密码不一致');
          return;
        }
      }
      return true;
    },
    updateUserinfoHandle() {
      if (this.validateUserForm()) {
        const entity = this.userForm.newPwd
          ? {
              name: this.userForm.name,
              newPwd: this.userForm.newPwd,
              oldPwd: this.userForm.pwd,
            }
          : {
              name: this.userForm.name,
            };
        this.updateUserinfo(entity)
          .then(res => {
            this.$message.success(res.msg || '修改成功');
            this.cancelUserinfoUpdate();
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
    cancelCellphoneUpdate(done) {
      this.resetCellphoneForm();
      typeof done === 'function' && done();
    },
    resetCellphoneForm() {
      this.cellphoneForm = {
        cellphone: '',
        vcode: '',
        svcode: '',
      };
      this.cellphoneDialogVisible = false;
    },
    validateCellphoneForm() {
      if (!this.cellphoneForm.cellphone) {
        this.$message.error('请输入更换手机号');
        return false;
      }
      if (!this.cellphoneForm.vcode) {
        this.$message.error('请输入验证码');
        return false;
      }

      return true;
    },
    updateCellphone() {
      if (this.validateCellphoneForm()) {
        const entity = {
          cellphone: this.cellphoneForm.cellphone,
          checkCode: this.cellphoneForm.vcode,
        };
        this.updateUserCellphone(entity)
          .then(res => {
            this.resetCellphoneForm();
            this.$message.success(res.msg || '修改成功');
            this.cancelCellphoneUpdate();
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../../assets/styles/variables.scss';
.avatar-container {
  margin-left: 44px;
  display: flex;
  align-items: center;
  color: #fff;
  line-height: 22px;
  font-size: 12px;
  flex: 1;
  .avatar-container-line {
    margin: 0 20px;
  }
  .avatar-name {
    display: flex;
    align-items: center;
    line-height: 20px;
    font-size: 14px;
    margin-right: 20px;
    .avatar-name-icon {
      position: relative;
      margin-left: 6px;
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
    .UserMenus {
      position: absolute;
      z-index: 2;
      top: 20px;
      right: -10px;
      width: 148px;
      background-color: #3bbda5;
      border-radius: 8px;
      font-size: 14px;
      overflow: hidden;
      .UserMenus-Link {
        cursor: pointer;
        height: 30px;
        line-height: 30px;
        display: flex;
        align-items: center;
        .UserMenus-Link-icon {
          width: 12px;
          height: 12px;
          margin: 0 10px 0;
        }
      }
      .UserMenus-Link:hover {
        background-color: #00997d;
      }
    }
  }
  .avatar-quit {
    cursor: pointer;
    font-size: 10px;
    line-height: 24px;
    .avatar-quit-icon {
      display: inline-block;
      margin-left: 10px;
      margin-top: -2px;
      width: 20px;
      height: 18px;
      vertical-align: middle;
    }
  }
  .avatar-wrapper {
    cursor: pointer;
    color: #a0acb9;
    position: relative;
    .user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 10px;
    }
    .el-icon-caret-bottom {
      position: absolute;
      right: -18px;
      top: 6px;
      font-size: 12px;
    }
  }
  .setpwd-info {
    color: red;
  }
  .userForm {
    .el-form-item {
      margin-bottom: 12px;
    }
  }
  .cellphoneForm {
    .vcode-wrap {
      display: flex;
      align-items: center;
    }
    .el-input {
      flex: 1;
    }
    .vcode-box {
      width: 100px;
      text-align: center;
      cursor: pointer;
      color: $menuHover;
    }
  }
  .showPassword {
    position: absolute;
    top: 15px;
    right: 10px;
    width: 20px;
    height: 12px;
  }
}
.img-code-box {
  display: flex;
  align-items: center;
  .code-img {
    width: 80px;
    height: 32px;
    margin-left: 20px;
  }
}
@media screen and (min-width: $bigScreenWidth) {
  .avatar-container {
    font-size: 18px;
    .avatar-name {
      line-height: 30px;
      font-size: 24px;
      .UserMenus {
        font-size: 18px;
        top: 35px;
        .UserMenus-Link {
          height: 46px;
          line-height: 46px;
          .UserMenus-Link-icon {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
    .avatar-quit {
      font-size: 14px;
    }
  }
}
</style>
